<template>
  <div class="content">
    <div class="breadlist">
      <bread-list :routeQuery="routeQuery"></bread-list>
      <div>
        <div class="video-name weight fs-xl">
          {{ videoData.name }}
        </div>
        <div class="fs-md video-date">
          {{ videoData.teacherName }} · {{ videoData.createTime | formateDate }}
          <!-- {{ videoData.times }}播放 · -->
          <!-- {{ videoData.startTime | formateDate }}~{{
            videoData.endTime | formateDate
          }} -->
        </div>
        <div class="video-play">
          <!-- <video :src="videoData.path"></video> -->
          <div class="video-video">
            <video-player
              class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions"
            ></video-player>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BreadList from '../../components/BreadList/indexnew.vue'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
import { formateDate } from '../../assets/js/date'
import { getVideoInfo } from '@/api/api'
export default {
  components: {
    BreadList,
    videoPlayer,
  },
  data() {
    return {
      videoData: {
        id: 0,
        name: '毛振明《体育教学论》（第3版）配套题库【课后习题＋专项题库】',
        author: '张三',
        times: '109',
        date: '2022-02-10 14:17:42',
        img: require('../../assets/img/vedio01.png'),
      },
      routeQuery: '',
      videoId: '',
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: '', //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: '', //url地址
          },
        ],
        poster: '', //你的封面地址
        width: '1000px', //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
    }
  },
  filters: {
    formateDate(time) {
      let date = new Date(time)
      return formateDate(date, 'yyyy-MM-dd')
    },
  },
  computed: {
    // player() {
    //   return this.$refs.videoPlayer.player
    // },
  },
  created() {
    this.routeQuery = this.$route.query
    this.routeQuery.path1 = '/teaching'
    this.routeQuery.path2 = '/video'
    this.routeQuery.three = '视频详情'
    this.routeQuery.keepalive = 0
    this.videoId = this.routeQuery.videoId
    getVideoInfo(this.routeQuery.videoId).then((res) => {
      this.videoData = res.data.obj
      this.playerOptions.sources[0].src = this.videoData.videoFile.path
      this.$forceUpdate()
    })
  },
  methods: {
    // onPlayerPlay(player) {},
    // onPlayerPause(player) {},
    // playerStateChanged(playerCurrentState) {},
    // playerReadied(player) {},
  },
}
</script>
<style lang="scss" scoped>
.content {
  width: 1100px;
  margin-left: calc(50% - 550px);
}
.video-name {
  color: #2f2f2f;
}
.video-date {
  color: #8b8b8b;
  margin-top: 8px;
  margin-bottom: 8px;
}
.video-play {
  width: 100%;
  //   height: 690px;
  margin-bottom: 24px;
  border: 1px solid #ededed;
}
.video-video {
  width: 100%;
  height: auto;
}
.video-js .vjs-icon-placeholder {
  width: 100%;
  height: 100%;
  display: block;
}
.video-video ::v-deep .vjs-big-play-button {
  margin-left: 495px;
  margin-top: 25%;
}
</style>
